import { useApp } from "@/context/AppContext";
import { FAQS } from "@/lib/site";
import { Seo, PageHeader, CtaLink } from "@/components/common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQPage() {
  const { t } = useApp();
  return (
    <main data-testid="faq-page">
      <Seo title={t({ tr: "Sık Sorulan Sorular", en: "Frequently Asked Questions" })} description={t({ tr: "Tedavi süresi, garanti kapsamı, konaklama ve daha fazlası hakkında sık sorulan sorular.", en: "Frequently asked questions about treatment duration, warranty scope, accommodation and more." })} />
      <PageHeader
        tag={{ tr: "SSS", en: "FAQ" }}
        title={{ tr: "Sık sorulan sorular", en: "Frequently asked questions" }}
        subtitle={{ tr: "Cevabını bulamadığınız sorular için koordinatörümüz her zaman ulaşılabilir.", en: "For anything not answered here, our coordinator is always reachable." }}
      />
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-8">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`} className="rounded-xl glass-card px-6" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-sm font-semibold text-[#F2F5F7] hover:no-underline">{t(f.q)}</AccordionTrigger>
              <AccordionContent className="text-sm text-[#94A3AE] leading-relaxed">{t(f.a)}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-12 text-center">
          <CtaLink to="/iletisim" testId="faq-contact-cta" variant="ghost">{t({ tr: "Sorunuzu bize iletin", en: "Send us your question" })}</CtaLink>
        </div>
      </section>
    </main>
  );
}
